import React from 'react';
import { Card, Typography, Form, Input, Button, message, Divider } from 'antd';

const { Title } = Typography;

const Settings: React.FC = () => {
  const [form] = Form.useForm();

  const handleSave = async (values: any) => {
    message.success('Settings saved successfully');
  };

  return (
    <div className="page-container">
      <div className="page-header">
        <Title level={2}>Settings</Title>
        <p>Manage your account and application settings</p>
      </div>

      <Card title="Profile Settings" className="hover-card" style={{ marginBottom: '24px' }}>
        <Form form={form} layout="vertical" onFinish={handleSave}>
          <Form.Item label="Username" name="username" initialValue="aethera">
            <Input disabled />
          </Form.Item>
          <Form.Item label="Email" name="email" initialValue="info@aetherahealthcare.com">
            <Input />
          </Form.Item>
          <Form.Item>
            <Button type="primary" htmlType="submit">
              Save Changes
            </Button>
          </Form.Item>
        </Form>
      </Card>

      <Card title="Integrations" className="hover-card">
        <p>Gmail, Twilio, and other integrations will be configurable here.</p>
        <Divider />
        <p>Integration setup will be available in Phase 2.</p>
      </Card>
    </div>
  );
};

export default Settings;
